import React from 'react';
import PropTypes from 'prop-types';
import { filter, propEq, isEmpty, isNil } from 'ramda';

import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';

import {
  CustomCalloutsAlert,
  CustomCalloutsBanner,
  CustomCalloutsMarkdown,
} from './';
import { getBlueprintName } from '../../utils/blueprintUtils';
import { getLocaleOrAvailable } from '../../utils/localeUtils';
import FEATURES from '../../constants/features';
import { useEventContext, useLocaleContext } from '../../contexts';
import { EHCustomCallouts } from '../../models/EHCustomCallouts';

const CustomCallouts = ({ blueprint, calloutsSection }) => {
  const [userLocale] = useLocaleContext();
  const { event } = useEventContext();

  if (!event.hasFeature(FEATURES.customCallouts)) return null;

  const customCallouts = new EHCustomCallouts(
    event.getMetadata(FEATURES.customCallouts)
  );
  const callouts = customCallouts[calloutsSection];
  const blueprintName = getBlueprintName(blueprint?.arn);
  const filterCallouts = filter(propEq('name', blueprintName));
  const filteredCallouts = filterCallouts(callouts);

  if (isEmpty(filteredCallouts)) return null;

  return (
    <SpaceBetween size="s">
      {filteredCallouts.map((callout, idx) => {
        if (isNil(callout.locales) || isEmpty(callout.locales)) return null;

        const { content, alert, banner } = getLocaleOrAvailable(
          userLocale,
          callout
        );

        switch (callout.type) {
          case 'alert':
            return <CustomCalloutsAlert key={idx} alert={alert} />;
          case 'banner':
            return (
              <CustomCalloutsBanner
                key={idx}
                locale={userLocale}
                banner={banner}
                content={content}
              />
            );
          case 'markdown':
            return (
              <CustomCalloutsMarkdown
                key={idx}
                locale={userLocale}
                content={content}
              />
            );
          default:
            return null;
        }
      })}
    </SpaceBetween>
  );
};

CustomCallouts.propTypes = {
  blueprint: PropTypes.object,
  calloutsSection: PropTypes.oneOf(['labs']).isRequired,
};

export default CustomCallouts;
